
import { DeskData } from '@/datamodel/deskdata'
import { GameResult } from '@/datamodel/game-result'
import { GAME_TYPE } from '@/utils/constants'
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { BetViewBaseMixin } from '../desk/betview/bet-view-mixin'
import MultiBaccaratBetView from './multi-baccarat-bet-view.vue'
import MultiDragonTigerBetView from './multi-dragon-tiger-bet-view.vue'
import { DeskOtherInfos, Table } from 'vue'
import { Getter } from 'vuex-class'

@Options({
    components: {
        MultiBaccaratBetView,
        MultiDragonTigerBetView
    }
})
export default class MultiBetView extends Vue {
    @Prop({ default: GAME_TYPE.BACCARAT })
    gameType!: string
    @Prop({ default: -1 })
    chipValue!: number
    @Prop({ default: false })
    allowBet!: boolean

    @Prop({ default: false })
    s6Mode!: boolean

    @Prop({ default: undefined }) currentDesk!: Table

    @Getter('memberId') memberId!: number

    $refs!: Vue['$refs']

    redConfirmed = 0
    blueConfirmed = 0
    greenConfirmed = 0
    bluePairConfirmed = 0
    redPairConfirmed = 0
    super6Confirmed = 0
    redSuper6Confimed = 0

    dragonSevenTemp = 0
    bearEightTemp = 0
    bigTigerTemp = 0
    smallTigerTemp = 0

    dragonSevenConfirmed = 0
    bearEightConfirmed = 0
    bigTigerConfirmed = 0
    smallTigerConfirmed = 0

    mWin = -1
    juNo = 0

    resetBet(): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin
        if (bettingView) {
            bettingView.OnCancelBetTemp()
            bettingView.ResetConfirmedTemp()
        }
    }

    showResult(deskResult: GameResult | undefined): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin
        if (bettingView) bettingView.showResult(deskResult)
    }

    hideGameResult(): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin
        if (bettingView) bettingView.hideGameResult()
    }

    get deskId(): number {
        if (this.currentDesk) return this.currentDesk.id || -1
        return -1
    }

    get deskOtherInfos(): DeskOtherInfos | undefined {
        if (this.currentDesk) {
            return {
                juNo: this.currentDesk.expand.juNo,
                shoeNo: this.currentDesk.expand.shoeNo,
                gameNo: this.currentDesk.expand.gameNo
            }
        } else return undefined
    }

    @Watch('currentDesk', { deep: true })
    DeskDataChange(): void {
        const bettingView = this.$refs['bettingview'] as BetViewBaseMixin
        if (bettingView) bettingView.ResetConfirmedTemp()
        this.juNo = this.currentDesk?.expand.juNo || 0

        if (this.currentDesk && this.currentDesk.expand.betFormList) {
            // set confirmed bet here

            if (
                this.currentDesk.expand.betFormList &&
                this.currentDesk.expand.betFormList.length > 0
            ) {
                const { betFormList } = this.currentDesk.expand
                let redBet = 0
                let blueBet = 0
                let greenBet = 0
                let redPairBet = 0
                let bluePairBet = 0
                let bankerFree = 0
                let super6 = 0

                let dragon7 = 0
                let bear8 = 0
                let bigTiger = 0
                let smallTiger = 0

                betFormList.forEach(betInfo => {
                    if (betInfo.memberId === this.memberId) {
                        const { playName, amount } = betInfo
                        if (playName === '庄') {
                            redBet += amount
                        } else if (playName === '庄对') {
                            redPairBet += amount
                        } else if (playName === '闲') {
                            blueBet += amount
                        } else if (playName === '闲对') {
                            bluePairBet += amount
                        } else if (playName === '和') {
                            greenBet += amount
                        } else if (playName === '龙') {
                            redBet += amount
                        } else if (playName === '虎') {
                            blueBet += amount
                        } else if (playName === '超级六') {
                            super6 += amount
                        } else if (playName === '免佣庄') {
                            bankerFree += amount
                        } else if (playName === '龙七') {
                            dragon7 += amount
                        } else if (playName === '熊八') {
                            bear8 += amount
                        } else if (playName === '大老虎') {
                            bigTiger += amount
                        } else if (playName === '小老虎') {
                            smallTiger += amount
                        }
                    }
                })

                this.redConfirmed = redBet
                this.blueConfirmed = blueBet
                this.greenConfirmed = greenBet
                this.redPairConfirmed = redPairBet
                this.bluePairConfirmed = bluePairBet
                this.super6Confirmed = super6
                this.redSuper6Confimed = bankerFree

                this.dragonSevenConfirmed = dragon7
                this.bearEightConfirmed = bear8
                this.bigTigerConfirmed = bigTiger
                this.smallTigerConfirmed = smallTiger
            } else {
                this.redConfirmed = 0
                this.blueConfirmed = 0
                this.greenConfirmed = 0
                this.redPairConfirmed = 0
                this.bluePairConfirmed = 0
                this.super6Confirmed = 0
                this.redSuper6Confimed = 0

                this.dragonSevenConfirmed = 0
                this.bearEightConfirmed = 0
                this.bigTigerConfirmed = 0
                this.smallTigerConfirmed = 0
            }
        }

        if (this.currentDesk.expand.daoJiShiBetTime < 0) {
            this.resetBet()
        }
    }
}
